import React, { Component } from 'react';
import { Drawer, Form, Button, Upload, Modal, Tabs, Table } from 'antd';
import { apiUtil as Util, API_CONFIG } from '../../mock/mockServices';

const { Dragger } = Upload;
const { TabPane } = Tabs;
const { confirm } = Modal;

// Status display mapping
const statusSet = [
  null,
  <span style={{ color: '#1890ff' }}>Submitted</span>,
  <span style={{ color: '#faad14' }}>Running</span>,
  <span style={{ color: '#52c41a' }}>Success</span>,
  <span style={{ color: '#ff4d4f' }}>Failed</span>
];

class EditForm extends Component {
  state = {
    activeTab: 'new',
    fileList: [],
    excuting: false,
    uploadedFilePath: null,
    predicted: false,
    predictionId: null, // Add prediction ID storage
    historicalPredictions: [],
    loadingHistorical: false,
    explainableModels: [], // 添加可解释模型列表
    explainablePredictions: {} // 存储每个模型的可解释预测ID列表
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.id && nextProps.id !== this.props.id) {
      this.setState({
        fileList: [],
        excuting: false,
        predicted: false,
        uploadedFilePath: null,
        activeTab: 'new',
        explainablePredictions: {} // Reset explainable predictions for new model
      });
      this.props.form.resetFields();
      // Fetch explainable predictions for the new model ID
      this.getExplainablePredictions(nextProps.id);
    }
  }

  formItemLayout = {
    labelCol: {
      sm: { span: 3 }
    },
    wrapperCol: {
      sm: { span: 19 }
    }
  };

  uploadConf = {
    name: 'file',
    multiple: false,
    accept: '.csv, .txt',
    showUploadList: {
      showDownloadIcon: false
    },
    // Use customRequest when in mock mode, otherwise use action
    ...(API_CONFIG.useMockData ? {
      customRequest: (options) => {
        const { onSuccess, onError } = options;

        // Simulate upload delay for mock data
        setTimeout(() => {
          if (Math.random() > 0.1) { // 90% success rate
            // Simulate successful upload response
            onSuccess({
              data: `mock_prediction_file_${Date.now()}.csv`,
              message: null
            });
          } else {
            onError(new Error("Upload failed"));
          }
        }, 1000);
      }
    } : {
      action: '/get/upload',
      data: {
        pathType: 'predict_file'
      },
      headers: {
        token: localStorage.authToken
      }
    }),
    beforeUpload: function (file) {
      console.log(file.type);
      const isScvOrTxt = /^.*(\.csv|\.txt)$/.test(file.name.toLocaleLowerCase());
      if (!isScvOrTxt) {
        Util.message.error('Please upload .CSV or .TXT file');
      }
      return isScvOrTxt;
    },
    onChange: info => {
      const { status } = info.file;
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      this.setState({ fileList });
      // console.log('status change：', status)
      if (status === 'done') {
        if (API_CONFIG.useMockData) {
          // Handle mock data response
          this.setState({ uploadedFilePath: info.file.response?.data || `mock_uploaded_${info.file.name}` });
        } else {
          // Handle real API response
          if (info.file.response.message) {
            Util.message.error(info.file.response.message);
            this.setState({ fileList: [], uploadedFilePath: '' });
          } else {
            this.setState({ uploadedFilePath: info.file.response.data });
          }
        }
      }
      if (status === 'error' || status === 'removed') {
        info.file.error && Util.message.error(info.file.error.message);
        this.setState({ fileList: [], uploadedFilePath: '' });
        if (info.file.response && info.file.response.code === '401') {
          window.location.href = '/login?rederect=' + encodeURIComponent(window.location.pathname)
        }
      }
    }
  };

  componentDidMount() {
    // 获取可解释的模型列表
    this.getExplainableModels();
    // 不再预先获取此模型的可解释预测列表，只在需要时加载
  }

  // 获取可解释的模型列表
  getExplainableModels() {
    Util.ajax.get('/models').then(res => {
      if (res.success && Array.isArray(res.data)) {
        // 提取模型前缀作为可解释模型的标识
        const explainableModels = res.data.map(item => item.prefix);
        this.setState({
          explainableModels
        });
      }
    }).catch(error => {
      console.error('Failed to fetch explainable models:', error);
      // 在出错时使用默认的可解释模型列表
      this.setState({
        explainableModels: ['1', '2', '287'] // must match backend /models prefixes
      });
    });
  }

  // 检查模型是否支持解释功能
  isModelExplainable = (modelId) => {
    // 确保modelId是字符串类型，以便与explainableModels数组中的字符串匹配
    const modelIdStr = typeof modelId === 'string' ? modelId : String(modelId);
    return this.state.explainableModels.includes(modelIdStr);
  }

  // 检查特定预测是否可解释
  isPredictionExplainable = async (modelId, predictionId) => {
    // 首先检查是否已缓存该模型的可解释预测列表
    if (this.state.explainablePredictions[modelId]) {
      const cachedPredictions = this.state.explainablePredictions[modelId];
      const result = cachedPredictions.includes(String(predictionId));
      return result;
    }

    // 如果没有缓存，则获取并缓存
    const predictions = await this.getExplainablePredictions(modelId);
    const result = predictions.includes(String(predictionId));
    return result;
  }

    // 获取特定模型的可解释预测列表
  getExplainablePredictions = async (modelId) => {
    console.log('[getExplainablePredictions] Starting. modelId:', modelId);
    try {
      const response = await Util.ajax.get(`/explain/model/${modelId}/predictions`);
      console.log('[getExplainablePredictions] API Response:', response);
      if (response.success && Array.isArray(response.data)) {
        console.log('[getExplainablePredictions] Response data:', response.data);
        this.setState(prevState => {
          const modelIdStr = typeof modelId === 'string' ? modelId : String(modelId);
          const hasExplainablePredictions = response.data.length > 0;
          const updatedExplainableModels = hasExplainablePredictions
            ? [...new Set([...prevState.explainableModels, modelIdStr])]
            : prevState.explainableModels;

          const newState = {
            explainablePredictions: {
              ...prevState.explainablePredictions,
              [modelId]: response.data
            },
            explainableModels: updatedExplainableModels
          };
          console.log('[getExplainablePredictions] setState with newState:', newState);
          return newState;
        }, () => {
          console.log('[getExplainablePredictions] setState completed');
          console.log('[getExplainablePredictions] Current explainablePredictions state:', this.state.explainablePredictions);
        });
        return response.data;
      } else {
        console.log('[getExplainablePredictions] Response not successful or data not array');
        return [];
      }
    } catch (error) {
      console.error('[getExplainablePredictions] Failed to fetch explainable predictions for model', modelId, ':', error);
      return [];
    }
  }

  onClose = () => {
    if (this.state.excuting) {
      confirm({
        title: 'Confirm Exit?',
        content: 'Exiting the window will interrupt the local prediction task',
        okType: 'danger',
        okText: 'Exit',
        cancelText: 'Cancel',
        onOk: () => {
          this.killTask();
          this.props.onClose();
        }
      });
    } else {
      this.props.onClose();
    }
  };

  checktrainStatus = id => {
    this.state.excuting && setTimeout(() => {
      Util.ajax.get(`/predict/getLocalPredict/${id}`).then(res => {
        if (res.data.predictStatus === 3) {
          Util.message.success('Prediction Complete');

          // Await explainable predictions before setting state to avoid race condition
          this.getExplainablePredictions(this.props.id).then(() => {
            this.setState({
              excuting: false,
              predicted: true,
              predictionId: res.data.id
            });
            window.onbeforeunload = null;
          });
        } else if (res.data.predictStatus === 4) {
          Util.message.error('Prediction Failed');
          this.setState({
            excuting: false
          });
          window.onbeforeunload = null;
        } else {
          this.checktrainStatus(id);
        }
      });
    }, 2000);
  };

  killTask = () => {
    Util.ajax.get(`/predict/killLocalPredictTask`, {
      trainId: this.props.id
    }).then(res => {
      Util.message.success('Prediction Interrupted');
      window.onbeforeunload = null;
      this.setState({
        excuting: false,
        predicted: false
      });
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ excuting: true, predicted: false });
    window.onbeforeunload = function () {
      return "Exiting or refreshing the page will interrupt the local prediction task, are you sure?";
    };
    Util.ajax.post('/predict/publishLocalPredictTask', {
      trainId: this.props.id,
      fileName: this.state.uploadedFilePath
    }).then(() => {
      this.checktrainStatus(this.props.id);
    }).catch(() => {
      this.setState({ excuting: false });
      window.onbeforeunload = null;
    });
  };

  downloadPredict = () => {
    window.open(`/get/predict/download/localPredict/${this.props.id}`);
  };

  downloadPredictreport = () => {
    window.open(`/get/predict/download/localReport/${this.props.id}`);
  };

  handleTabChange = (activeKey) => {
    console.log('[handleTabChange] Tab changed to:', activeKey, 'from:', this.state.activeTab);

    if (activeKey === 'historical') {
      console.log('[handleTabChange] Loading historical predictions FIRST, then switching tab');
      this.loadHistoricalPredictions().then(() => {
        console.log('[handleTabChange] Data loaded, now switching tab to:', activeKey);
        this.setState({ activeTab: activeKey }, () => {
          console.log('[handleTabChange] activeTab updated to:', this.state.activeTab);
        });
      });
    } else {
      console.log('[handleTabChange] Switching to non-historical tab:', activeKey);
      this.setState({ activeTab: activeKey }, () => {
        console.log('[handleTabChange] activeTab updated to:', this.state.activeTab);
      });
    }
  };

  loadHistoricalPredictions = () => {
    console.log('[loadHistoricalPredictions] Starting to load. modelId:', this.props.id);
    this.setState({ loadingHistorical: true });

    return Util.ajax.post('/predict/getLocalPredictList', {
      pageNum: 1,
      pageSize: 10,
      trainId: this.props.id
    }).then(res => {
      console.log('[loadHistoricalPredictions] API Response:', res);
      const predictions = res.data.list || [];
      console.log('[loadHistoricalPredictions] Parsed predictions:', predictions);

      return this.getExplainablePredictions(this.props.id).then(() => {
        console.log('[loadHistoricalPredictions] After getExplainablePredictions');
        console.log('[loadHistoricalPredictions] Current explainablePredictions state:', this.state.explainablePredictions);

        // The job store may not know about prediction jobs produced by the
        // model-explainer backend; merge those in so every explainable
        // prediction shows up with a working Explain action.
        const explainableIds = this.state.explainablePredictions[this.props.id] || [];
        const knownIds = new Set(predictions.map(p => String(p.id)));
        const missingPredictions = explainableIds
          .filter(pid => !knownIds.has(String(pid)))
          .map(pid => ({
            id: pid,
            predictFilePath: `prediction/${pid}`,
            createTime: null,
            predictStatus: 3
          }));
        const mergedPredictions = predictions.concat(missingPredictions);

        this.setState({
          historicalPredictions: mergedPredictions,
          loadingHistorical: false
        }, () => {
          console.log('[loadHistoricalPredictions] setState completed');
          console.log('[loadHistoricalPredictions] Final historicalPredictions:', this.state.historicalPredictions);
          console.log('[loadHistoricalPredictions] Final explainablePredictions:', this.state.explainablePredictions);
        });
      });
    }).catch((error) => {
      console.error('Failed to load historical predictions:', error);
      // The prediction-job store is not part of the model-explainer backend;
      // fall back to the explainer's own /predictions list so each known
      // prediction job still shows up here with a working Explain action.
      return this.getExplainablePredictions(this.props.id).then((predictions) => {
        const fallbackList = (predictions || []).map(pid => ({
          id: pid,
          predictFilePath: `prediction/${pid}`,
          createTime: null,
          predictStatus: 3
        }));
        this.setState({
          historicalPredictions: fallbackList,
          loadingHistorical: false
        });
      }).catch(() => {
        this.setState({ loadingHistorical: false });
        Util.message.error('Failed to load historical predictions');
      });
    });
  };

  handleExplain = (record) => {
    // Close the prediction drawer and open the model explanation drawer
    this.props.onClose();
    // Call the onExplain callback if provided
    if (this.props.onExplain) {
      // Add a property to indicate this is from historical prediction
      const explainRecord = {
        ...record,
        fileName: record.predictFilePath || record.fileName, // Use predictFilePath from API response, fallback to fileName
        modelId: this.props.id, // Pass modelId for explainability check
        predictionId: record.id, // Pass predictionId for prediction-specific API calls
        projectName: this.props.projectName || record.projectName // Pass projectName for the explanation title
      };
      this.props.onExplain(explainRecord);
    }
  };

  renderNewPredictionTab = () => {
    const Action = props => {
      if (this.state.excuting) {
        return <div>
          <Button size="large" icon="loading" type="danger" onClick={this.killTask}> Click to Interrupt </Button>
          <span style={{ color: '#f33', paddingLeft: '20px' }}>Executing, please do not leave</span>
        </div>;
      } else {
        return <div>
          {
            !this.state.predicted &&
            <Button size="large" disabled={!this.state.uploadedFilePath} onClick={this.handleSubmit} type="primary"> Execute Prediction </Button>
          }
          {
            this.state.predicted &&
            <span>
              <Button size="large" onClick={() => this.handleExplain({ id: this.state.predictionId || this.props.id, fileName: this.state.uploadedFilePath, trainId: this.props.id, predictionId: this.state.predictionId || this.props.id })} type="primary"> Explain </Button>
            </span>
          }
        </div>;
      }
    };

    return (
      <Form {...this.formItemLayout}>
        <Form.Item label="Upload Data" >
          <Dragger {...this.uploadConf} fileList={this.state.fileList}>
            <div className="bui-cols">
              <div className="ant-upload-drag-icon"><i className="iconfont">&#xe664;</i></div>
              <div className="bui-col-1 tl">
                <p className="ant-upload-text">Click or drag a file here</p>
                <p className="ant-upload-hint">Support .CSV or .TXT files, with English headers </p>
              </div>
            </div>
          </Dragger>
        </Form.Item>
        <Form.Item style={{ marginLeft: '12.5%' }}>
          <Action></Action>
        </Form.Item>
      </Form>
    );
  };

  renderHistoricalPredictionTab = () => {
    const explainablePredictions = this.state.explainablePredictions[this.props.id] || [];
    console.log('[Historical Tab Render] modelId:', this.props.id);
    console.log('[Historical Tab Render] explainablePredictions:', explainablePredictions);
    console.log('[Historical Tab Render] historicalPredictions count:', this.state.historicalPredictions.length);
    console.log('[Historical Tab Render] historicalPredictions:', this.state.historicalPredictions);
    console.log('[Historical Tab Render] loadingHistorical:', this.state.loadingHistorical);

const columns = [
      {
        title: 'Prediction ID',
        dataIndex: 'id',
        key: 'id',
        width: 100
      },
      {
        title: 'File Path',
        dataIndex: 'predictFilePath',
        key: 'predictFilePath',
        render: (path) => {
          const fileName = path ? path.split('/').pop() : 'N/A';
          return fileName;
        },
        width: 200
      },
      {
        title: 'Creation Time',
        dataIndex: 'createTime',
        key: 'createTime',
        render: time => (time != null ? Util.dateFormat(time) : '-'),
        width: 150
      },
      {
        title: 'Status',
        dataIndex: 'predictStatus',
        key: 'predictStatus',
        render: status => statusSet[status] || 'Unknown',
        width: 100
      },
      {
        title: 'Actions',
        key: 'actions',
        render: (text, record) => {
          const isModelExplainable = this.isModelExplainable(this.props.id);
          const isPredictionExplainable = explainablePredictions.includes(String(record.id));

          console.log('[Actions Render] record.id:', record.id);
          console.log('[Actions Render] record.predictStatus:', record.predictStatus);
          console.log('[Actions Render] record.predictResultPath:', record.predictResultPath);
          console.log('[Actions Render] isModelExplainable:', isModelExplainable);
          console.log('[Actions Render] isPredictionExplainable:', isPredictionExplainable);
          console.log('[Actions Render] explainablePredictions:', explainablePredictions);

          return (
          <div>
            {record.predictStatus === 3 && record.predictResultPath && (
              <Button
                type="link"
                size="small"
                onClick={() => window.open(`/get/predict/download/${record.predictResultPath}`)}
                style={{ display: 'none' }}
              >
                Download Results
              </Button>
            )}
            <Button
              type="primary"
              size="small"
              onClick={() => this.handleExplain(record)}
              disabled={!isModelExplainable || !isPredictionExplainable}
              style={{ marginLeft: 8 }}
            >
              Explain
            </Button>
           </div>
        )},
        width: 150
      }
    ];

    console.log('[Historical Tab Render] columns count:', columns.length);
    console.log('[Historical Tab Render] columns:', columns.map(col => col.title));

    return (
      <div>
        <Table
          columns={columns}
          dataSource={this.state.historicalPredictions}
          loading={this.state.loadingHistorical}
          rowKey="id"
          pagination={{
            pageSize: 5,
            showTotal: (total) => `Total ${total} items`
          }}
        />
        {console.log('[Historical Tab Render] Table rendered with', columns.length, 'columns')}
      </div>
    );
  };

  render() {
    return (
      <div>
        <Drawer
          title={
            <div>Prediction
              <div className="sub-title">Upload .CSV or .TXT file locally, perform prediction on a specific ID set</div>
            </div>
          }
          width={700}
          maskClosable={true}
          onClose={this.onClose}
          visible={this.props.visible}
        >
          <Tabs activeKey={this.state.activeTab} onChange={this.handleTabChange}>
            <TabPane tab="Historical Prediction" key="historical">
              {this.renderHistoricalPredictionTab()}
            </TabPane>
            <TabPane tab="New Prediction" key="new">
              {this.renderNewPredictionTab()}
            </TabPane>
          </Tabs>
          <div className="drawer-footer">
            <Button onClick={this.onClose} style={{ marginRight: 8 }}>Close</Button>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default Form.create({ name: 'publish-edit-form' })(EditForm);